/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Link, Typography } from '@mui/material';
import DashboardContainer from 'components/PageContainer/DashboardContainer';
import Spinner from 'components/public/Spinner/Spinner';
import NoResponse from 'pages/auxiliares/NoResponse';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { RootState, AppDispatch } from 'utils/redux/store/store';
import { ChevronLeft, EventAvailableOutlined } from '@mui/icons-material';
import Formulario from 'components/public/Formulario/Formulario';
import { IFormato, IFormulario, ISelectOptions } from 'utils/models/interfaces';
import { crearOpcionesTipos } from 'utils/utilities';
import { fetchGeneros } from 'utils/redux/features/generosSlice';
import { fetchTiposElenco } from 'utils/redux/features/tiposElencoSlice';
import { useError } from 'services/ErrorContext';
import { Espectaculo, IRequestEspectaculo } from 'utils/models/types';
import { fetchEspectaculoPorId } from 'utils/redux/features/espectaculoPorIdSlice';
import { edicionEspectaculo } from 'services/servicioPut';
import CaratulaObra from 'components/public/FichaEspectaculo/CaratulaObra';
import NoImage from 'assets/afichesObras/No-image.jpg';
import { theme } from 'theme/theme';
import { anchoMaxLogueado } from 'utils/constants';

const EdicionEspectaculo = () => {
  const { id } = useParams();
  const { espectaculo, loadingEspectaculo, errorEspectaculo } = useSelector((state: RootState) => state.espectaculo);
  const { tiposElenco, loadingTiposElenco, errorTiposElenco } = useSelector((state: RootState) => state.tiposElenco);
  const { generos, loadingGeneros, errorGeneros } = useSelector((state: RootState) => state.generos);
  const { error, clearError, loading, setError, setLoading } = useError();

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const error401 = errorEspectaculo?.includes('permisos');
  const opcionesTipoElenco: ISelectOptions[] = crearOpcionesTipos(tiposElenco, 'TipoElenco');
  const opcionesGenero: ISelectOptions[] = crearOpcionesTipos(generos, 'Genero');
  const [fotos, setFotos] = useState<FileList>();

  // @ts-expect-error -- form field typed by react-hook-form, not in interface
  const tipoElencoId = tiposElenco.find(tipoElenco => tipoElenco.Nombre === espectaculo.TipoElenco)?.Id;
  // @ts-expect-error -- form field typed by react-hook-form, not in interface
  const generoId = generos.find(gen => gen.Nombre === espectaculo.Genero)?.Id;

  const {
    Nombre,
    VisibleEnGrilla,
    AforoDisponible,
    PorcentajeAgadu,
    PorcentajeCofonte,
    BannerDestacado,
    Autor,
    Elenco,
    Director,
    Precio,
    Descripcion,
    AsistenteDireccion,
    Vestuarista,
    Iluminador,
    Sonidista,
    Musica,
    DisenoGrafico,
    Traduccion,
    Escenografia,
    Fotografia,
  } = espectaculo;

  const datosEdicionEspectaculo: IFormato<Espectaculo>[] = [
    { name: 'Nombre', label: 'Nombre del espectáculo', subtituloSeccion: 'Sobre la obra', defaultValue: Nombre },
    { name: 'Descripcion', label: 'Descripcion del espectáculo', inputType: 'textarea', defaultValue: Descripcion },
    { name: 'Genero', label: 'Género de la obra', inputType: 'select', defaultValue: generoId },
    { name: 'Autor', label: 'Nombre del autor', subtituloSeccion: 'Integrantes de la obra', defaultValue: Autor },
    { name: 'Director', label: 'Nombre del director', defaultValue: Director },
    { name: 'TipoElenco', label: 'Tipo de elenco', inputType: 'select', defaultValue: tipoElencoId },
    { name: 'Elenco', label: 'Elenco', inputType: 'textarea', defaultValue: Elenco },
    {
      name: 'AsistenteDireccion',
      label: 'Nombre del asistente de dirección',
      required: false,
      halfWidth: 'left',
      subtituloSeccion: 'Técnicos de la obra',
      defaultValue: AsistenteDireccion,
    },
    { name: 'Vestuarista', label: 'Vestuarista', required: false, halfWidth: 'right', defaultValue: Vestuarista },
    { name: 'Iluminador', label: 'Iluminación', required: false, halfWidth: 'left', defaultValue: Iluminador },
    { name: 'Sonidista', label: 'Sonidista', required: false, halfWidth: 'right', defaultValue: Sonidista },
    { name: 'Musica', label: 'Música', required: false, halfWidth: 'left', defaultValue: Musica },
    {
      name: 'DisenoGrafico',
      label: 'Diseño gráfico',
      required: false,
      halfWidth: 'right',
      defaultValue: DisenoGrafico,
    },
    { name: 'Fotografia', label: 'Fotografía', required: false, halfWidth: 'left', defaultValue: Fotografia },
    { name: 'Escenografia', label: 'Eescenografia', required: false, halfWidth: 'right', defaultValue: Escenografia },
    { name: 'Traduccion', label: 'Traducción', required: false, defaultValue: Traduccion },
    {
      name: 'Afiche',
      label: 'Subir nuevo afiche',
      inputType: 'file',
      subtituloSeccion: 'Multimedia',
      required: false,
    },
    { name: 'Banner', label: 'Subir nuevo banner', inputType: 'file', required: false },
    { name: 'Fotos', label: 'Subir nuevas fotos', inputType: 'dropzone', required: false },
    {
      name: 'AforoDisponible',
      label: 'Cantidad de asientos disponibles',
      inputType: 'number',
      subtituloSeccion: 'Aspectos operativos y financieros',
      defaultValue: AforoDisponible,
    },
    { name: 'Precio', label: 'Precio de la entrada', inputType: 'number', adornment: '$', defaultValue: Precio },
    {
      name: 'PorcentajeAgadu',
      label: 'Impuesto de AGADU',
      inputType: 'number',
      halfWidth: 'left',
      adornment: '%',
      defaultValue: PorcentajeAgadu,
    },
    {
      name: 'PorcentajeCofonte',
      label: 'Impuesto de COFONTE',
      inputType: 'number',
      halfWidth: 'right',
      adornment: '%',
      defaultValue: PorcentajeCofonte,
    },
    {
      name: 'VisibleEnGrilla',
      label: 'Visible en grilla',
      inputType: 'checkbox',
      required: false,
      halfWidth: 'left',
      defaultValue: VisibleEnGrilla,
    },
    {
      name: 'BannerDestacado',
      label: '¿Destacar banner?',
      inputType: 'checkbox',
      required: false,
      halfWidth: 'right',
      defaultValue: BannerDestacado,
    },
  ];

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setFotos(event.target.files);
    }
  };

  useEffect(() => {
    id && dispatch(fetchEspectaculoPorId(Number(id)));
    dispatch(fetchTiposElenco());
    dispatch(fetchGeneros());
  }, [id, dispatch]);

  const [mensajeExito, setMensajeExito] = useState('');
  const [mostrarInicio, setMostrarInicio] = useState(true);

  async function handleSubmit(data: IFormulario): Promise<void> {
    clearError();

    const formData = new FormData();

    formData.append('Id', String(espectaculo.Id));
    formData.append('Nombre', data.Nombre);
    formData.append('VisibleEnGrilla', String(data.VisibleEnGrilla || false));
    formData.append('AforoDisponible', String(data.AforoDisponible));
    formData.append('TipoElencoId', String(data.TipoElenco || 0));
    formData.append('PorcentajeAgadu', String(data.PorcentajeAgadu));
    formData.append('PorcentajeCofonte', String(data.PorcentajeCofonte));
    formData.append('BannerDestacado', String(data.BannerDestacado));
    formData.append('SalaId', '1');
    formData.append('Autor', data.Autor);
    formData.append('Elenco', data.Elenco);
    formData.append('Director', data.Director);
    formData.append('GeneroId', String(data.Genero));
    formData.append('Precio', String(data.Precio));
    formData.append('Descripcion', data.Descripcion);
    formData.append('AsistenteDireccion', data.AsistenteDireccion || '');
    formData.append('Vestuarista', data.Vestuarista || '');
    formData.append('Iluminador', data.Iluminador || '');
    formData.append('Sonidista', data.Sonidista || '');
    formData.append('Musica', data.Musica || '');
    formData.append('DisenoGrafico', data.DisenoGrafico || '');
    formData.append('Traduccion', data.Traduccion || '');
    formData.append('Escenografia', data.Escenografia || '');
    formData.append('Fotografia', data.Fotografia || '');

    // @ts-expect-error -- form field typed by react-hook-form, not in interface
    const afiche: IFile = data?.Afiche[0];
    // @ts-expect-error -- form field typed by react-hook-form, not in interface
    const banner: IFile = data?.Banner[0];

    if (afiche) {
      formData.append('Afiche', afiche);
    }

    if (banner) {
      formData.append('Banner', banner);
    }

    if (fotos) {
      Array.from(fotos).forEach((file, index) => {
        formData.append(`Fotos`, file);
      });
    }

    const requestEspectaculo: IRequestEspectaculo = {
      Id: espectaculo.Id,
      Nombre: data.Nombre,
      VisibleEnGrilla: data.VisibleEnGrilla || false,
      AforoDisponible: data.AforoDisponible,
      // @ts-expect-error -- form field typed by react-hook-form, not in interface
      TipoElencoId: data.TipoElenco || 0,
      PorcentajeAgadu: data.PorcentajeAgadu,
      PorcentajeCofonte: data.PorcentajeCofonte,
      Afiche: afiche || '',
      Banner: banner || '',
      BannerDestacado: data.BannerDestacado,
      SalaId: 1,
      Fotos: null, // Las fotos se mandan mediante FormData
      Autor: data.Autor,
      Elenco: data.Elenco,
      Director: data.Director,
      // @ts-expect-error -- form field typed by react-hook-form, not in interface
      GeneroId: data.Genero,
      Precio: data.Precio,
      Descripcion: data.Descripcion,
      AsistenteDireccion: data.AsistenteDireccion || '',
      Vestuarista: data.Vestuarista || '',
      Iluminador: data.Iluminador || '',
      Sonidista: data.Sonidista || '',
      Musica: data.Musica || '',
      DisenoGrafico: data.DisenoGrafico || '',
      Traduccion: data.Traduccion || '',
      Escenografia: data.Escenografia || '',
      Fotografia: data.Fotografia || '',
    };

    try {
      // Formdata = true para que envíe con headers de tipo form-data
      await edicionEspectaculo(requestEspectaculo, setError, setLoading, true, formData);
      setMensajeExito('¡El espectáculo fue modificado con éxito!');
    } catch (error) {
      console.error('Error de edición:', error);
    }
  }

  const onEditarDatos = () => {
    setMostrarInicio(false);
  };

  const onAgregarFunciones = () => {
    setMostrarInicio(false);
    navigate(`/admin/espectaculos/${id}/funciones`);
  };

  const handleVolver = () => {
    setMensajeExito('');
    if (mostrarInicio) {
      navigate('/admin/espectaculos');
    } else {
      setMostrarInicio(true);
    }
  };

  const aficheObra = espectaculo.AficheUrl || NoImage;
  const isLoading = loadingEspectaculo || loadingTiposElenco || loadingGeneros || loading;

  return (
    <DashboardContainer>
      {isLoading ? (
        <Spinner />
      ) : errorEspectaculo || errorTiposElenco || errorGeneros ? (
        error401 ? (
          <NotAllowed />
        ) : (
          <NoResponse />
        )
      ) : (
        <>
          <Box width="100%" display="flex" ml={12} maxWidth={anchoMaxLogueado} mx="auto">
            <Button fullWidth={false} onClick={handleVolver} sx={{ ml: { sx: 3, md: 10 } }} startIcon={<ChevronLeft />}>
              Volver
            </Button>
          </Box>
          {mostrarInicio ? (
            <Box mb={6} mx="auto">
              <CaratulaObra color="white" afiche={aficheObra} nombre={espectaculo.Nombre} />
              <Typography mt={6} variant="h6" color={theme.palette.primary.main} fontSize="1.1rem">
                {`¿Qué tipo de edición buscás para ${espectaculo.Nombre}?`}
              </Typography>
              <Box
                display="flex"
                gap={{ xs: 0, md: 2 }}
                flexDirection={{ xs: 'column', md: 'row' }}
                px={{ xs: 1, md: 0 }}
              >
                <Button
                  component={Link}
                  variant="contained"
                  color="primary"
                  onClick={onEditarDatos}
                  sx={{ marginTop: 3, flex: '1' }}
                >
                  Editar datos
                </Button>
                <Button
                  component={Link}
                  variant="outlined"
                  color="primary"
                  onClick={onAgregarFunciones}
                  sx={{ marginTop: 3, flex: '1' }}
                >
                  Agregar funciones
                </Button>
              </Box>
            </Box>
          ) : (
            <Box maxWidth={anchoMaxLogueado} mx="auto">
              <Formulario
                campos={datosEdicionEspectaculo}
                titulo={`Editar ${espectaculo.Nombre}`}
                textoBoton="Actualizar"
                onSubmit={handleSubmit}
                datos={opcionesTipoElenco.concat(opcionesGenero)}
                onVolver={handleVolver}
                mensajeExito={mensajeExito}
                mensajeError={error}
                loading={loading}
                iconoBoton={EventAvailableOutlined}
                handleFileUpload={handleFileUpload}
                mensajeAlerta=" "
                tituloMensajeResp="Edición realizada correctamente"
              />
            </Box>
          )}
        </>
      )}
    </DashboardContainer>
  );
};

export default EdicionEspectaculo;
